import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_28_accounting_year_mapper: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Accounting years",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: LayoutTypes.FORM,
            Name: "accounting_year_mapper",
            TableName: "accounting_years",
            DisplayName: "Accounting years",
            columnNumber: "m1 t1 w3",
            style: {
              padding: 10,
              backgroundColor: "#ffffff",
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_accounting_year_id",
                label: "Accounting year",
                placeholder: "Enter accounting year",
                required: true,
                lookupName: "get_accounting_year_mapper",
                BindValue: "drp_accounting_year_id",
                Json_Attribute: "accounting_year_id",
                options: [],
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Accounting year is required",
                  },
                ],
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_from_date",
                label: "From date",
                placeholder: "dd-mm-yyyy",
                required: true,
                Json_Attribute: "from_date",
                IsVerticalView: true,

                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "From date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_to_date",
                label: "To date",
                placeholder: "dd-mm-yyyy",
                required: true,
                Json_Attribute: "to_date",
                IsVerticalView: true,

                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "To date is required",
                  },
                ],
              },
              {
                componentType: LayoutTypes.GROUP,
                style: {
                  direction: FlexDirection.ROW,
                  padding: 0,
                  gap: 12,
                },
                childComponents: [
                  {
                    componentType: ComponentType.BUTTON,
                    name: "Submit",
                    Label: "Submit",
                    BindValue: "btn_submit",
                    onPressAction: "save",
                    ActionType: "Add",
                    ScreenId: "28",
                    style: {
                      backgroundColor: "var(--primary-green)",
                      textColor: "#FFFFFF",
                      padding: 12,
                      borderRadius: 6,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

